import type { ReactNode } from "react"
import { SidebarProvider } from "@/shared/ui/sidebar"
import { Header } from "@/widgets/layout-header"
import { AppSidebar } from "@/widgets/layout-sidebar"

interface LayoutProps {
	children: ReactNode
}

/**
 * Main layout component wrapping sidebar and content area
 * Manages sidebar state via SidebarProvider with localStorage persistence
 */
export function Layout({ children }: LayoutProps) {
	return (
		<SidebarProvider defaultOpen={true}>
			{/* h-screen bounds scroll to <main>; mailing form footer needs a fixed viewport chain */}
			<div className="flex h-screen w-full overflow-hidden">
				<AppSidebar />
				<div className="flex min-h-0 flex-1 flex-col">
					<Header />
					<main className="min-h-0 flex-1 overflow-auto bg-[#F5F5F5]">
						{children}
					</main>
				</div>
			</div>
		</SidebarProvider>
	)
}
